import { Tabs as MantineTabs } from "@mantine/core";
import Tabs from "./Tabs";

export const TabComponents = MantineTabs;

export default Tabs;
